<template>
  <div class="Footer">
    Copyright © 2025 AIFly Technology Co.,Ltd. All Rights Reserved
  </div>
</template>

<style lang="scss" scoped>
.Footer {

}
</style>
<script setup lang="ts">
</script>
